import { SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { Product, ProductStock } from '@setvi/shared/interfaces';
import { getStock } from 'pages/products/components';
import { Customer } from 'Services/MongoRealm/Types';
import { Box, withStyles } from '@material-ui/core';
import { Skeleton as MUISkeleton } from '@material-ui/lab';
import { useRealTimeInventory } from 'pages/products/components/stock/useRealtimeInventory';
import { ProductValueWrapper } from '../product-value';

const Skeleton = withStyles({
  root: {
    backgroundColor: 'rgba(23, 23, 37, 0.11) !important'
  }
})(MUISkeleton);

interface ProductHeaderStockProps {
  product: Product;
  selectedCustomer?: Customer;
  stockRefresh?: ProductStock['refresh'];
  updateProduct: (product: Product, props: Partial<Product>) => void;
  onClick?: () => void;
}

export const ProductHeaderStock = ({
  product,
  selectedCustomer,
  stockRefresh,
  updateProduct,
  onClick
}: ProductHeaderStockProps) => {
  const { fetchRealtimeInventory, loading: isLoading } = useRealTimeInventory();

  const stock = getStock(product.inventory, selectedCustomer);
  const dropship = product?.dropship || false;

  const handleFetchRealtimeInventory = async (id: string) => {
    const res = await fetchRealtimeInventory(id);
    Array.isArray(res) && updateProduct?.(product, { inventory: res });
  };

  const content = () => {
    if (isLoading) return <Skeleton width={100} />;
    if (dropship)
      return (
        <SText title="Dropship" weight="semibold" fontColor={TextColor.Blue} />
      );
    if (!stock)
      return (
        <SText
          title="Out of stock"
          weight="semibold"
          fontColor={TextColor.Red}
        />
      );
    return (
      <ProductValueWrapper>
        <SText
          lineHeight="24px"
          title="In stock:"
          weight="bold"
          fontColor={TextColor.SlateGrey}
          style={{ marginRight: 4 }}
        />
        <SText
          lineHeight="24px"
          title={stock.toString()}
          fontColor={TextColor.Green}
          style={{ textDecoration: 'underline' }}
        />
      </ProductValueWrapper>
    );
  };

  return (
    <Box
      style={{ cursor: stockRefresh ? 'pointer' : 'default' }}
      onClick={() => {
        onClick?.();
        stockRefresh && handleFetchRealtimeInventory(product.sku);
      }}>
      {content()}
    </Box>
  );
};
